import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import './Styles/Slider.scss';
import profile1 from '../../../Assets/Cards/signupProfile.png';
import profile2 from '../../../Assets/Cards/profile1.png';
import profile3 from '../../../Assets/Cards/profile2.png';
import profile4 from '../../../Assets/Cards/profile3.png';
import profile5 from '../../../Assets/Cards/profile4.png';


import Panel from './Panel';
const Slider=()=>{
    return(
        <div className="signup-slider">
            <Tabs>
                <TabPanel>
                 <Panel 
                 feedback="HostDesign helps me save literal hours of work. It's one of my most invaluable tools with its ability to take my data and intelligently map it onto gorgeously designed and animated graphs."
                 name="Alexandar Hope"
                 job="Associate Editor, TechRadar"
                 profile={profile1}
                 />
                </TabPanel>
                <TabPanel>
                 <Panel 
                 feedback="HostDesign helps me save literal hours of work. It's one of my most invaluable tools with its ability to take my data and intelligently map it onto gorgeously designed and animated graphs."
                 name="Alexandar Hope"
                 job="Associate Editor, TechRadar"
                 profile={profile2}
                 />
                </TabPanel>
                <TabPanel>
                 <Panel 
                 feedback="HostDesign helps me save literal hours of work. It's one of my most invaluable tools with its ability to take my data and intelligently map it onto gorgeously designed and animated graphs."
                 name="Alexandar Hope"
                 job="Associate Editor, TechRadar"
                 profile={profile1}
                 />
                </TabPanel>
                <TabPanel>
                 <Panel 
                 feedback="HostDesign helps me save literal hours of work. It's one of my most invaluable tools with its ability to take my data and intelligently map it onto gorgeously designed and animated graphs."
                 name="Alexandar Hope"
                 job="Associate Editor, TechRadar"
                 profile={profile2}
                 />
                </TabPanel>
                <TabPanel>
                 <Panel 
                 feedback="HostDesign helps me save literal hours of work. It's one of my most invaluable tools with its ability to take my data and intelligently map it onto gorgeously designed and animated graphs."
                 name="Alexandar Hope"
                 job="Associate Editor, TechRadar"
                 profile={profile1}
                 />
                </TabPanel>
                <TabList>
                <Tab>01</Tab>
                <Tab>02</Tab>
                <Tab>03</Tab>
                <Tab>04</Tab>
                <Tab>05</Tab>
                </TabList>
             </Tabs>
        </div>
    )
};
export default Slider ;